/** IceSpy / dual-probe types: show 8-digit serial (e.g. 14764 → 00014764). */
const SERIAL_PAD_8_TYPES = new Set(['2', '6', '7']); // Hanwell IceSpy, EMS IceSpy Dual, EMS IceSpy PT100

export const formatSensorSerial = (serialNo: number | string | null | undefined, type?: string): string => {
  if (serialNo == null) return '—';
  const s = serialNo.toString();
  if (type != null && SERIAL_PAD_8_TYPES.has(type)) {
    return s.padStart(8, '0');
  }
  return s;
};

export function isNewerVersion(latestVersion: string, currentVersion: string): boolean {
  if (!currentVersion || !latestVersion) {
    return false;
  }
  
  const partsA = latestVersion.trim().split('.').map(Number);
  const partsB = currentVersion.trim().split('.').map(Number);
  const len = Math.max(partsA.length, partsB.length);

  for (let i = 0; i < len; i++) {
    const a = partsA[i] || 0;
    const b = partsB[i] || 0;
    if (a > b) return true;
    if (a < b) return false;
  }
  
  return false;
}